import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

import {MatTooltipModule} from '@angular/material/tooltip';
import {DxDataGridModule, DxPivotGridModule, DxTreeViewModule, DxListModule, DxContextMenuModule, DxTemplateModule, DxCheckBoxModule, DxSelectBoxModule, DxValidationSummaryModule, DxButtonModule, DxValidatorModule, DxBulletModule, DxLoadPanelModule, DxSortableModule, DxTabPanelModule, DxAccordionModule} from 'devextreme-angular';

import {ReporteRoutingModule} from './reporte-routing.module';
import {ComponentesModule} from '@componentes/Componentes.module';

import {ColaboradorComponent} from './colaborador/colaborador.component';
import {ColaboradorDetalleComponent} from './colaborador/colaborado_detalle.component';
import { ReporteEvaluacionPendientePreguntaEnviadaComponent } from './preguntaenviada/preguntaenviada.component';
import { ReporteEvaluacionPendientePreguntaEnviadaDetalleComponent } from './preguntaenviada/preguntaenviadadetalle/preguntaenviadadetalle.component';
import { ReporteEvaluacionPendientePreguntaEnviadaDetallePersonaEvaluaComponent } from './preguntaenviada/preguntaenviadadetalle/seccion/preguntaenviadadetalle_personaevalua.component';
import { ReporteEvaluacionPendientePreguntaEnviadaDetallePreguntaComponent } from './preguntaenviada/preguntaenviadadetalle/seccion/preguntaenviadadetalle_pregunta.component';
import { GlobalModule } from '../global/global.module';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PipesModule } from '@pipes/Pipes.module';
import { ReporteEvaluacionPendienteComponent } from './evaluacionpendiente/evaluacionpendiente.component';
import { ReporteEvaluacionPendienteDetalleComponent } from './evaluacionpendiente/evaluacionpendientedetalle.component';
import { ReporteEvaluacionComponent } from './evaluacion/evaluacion.component';
import { ReporteEvaluacionDetalleComponent } from './evaluacion/evaluaciondetalle/evaluaciondetalle.component';
import { ReporteEvaluacionDetalleAlumnoComponent } from './evaluacion/evaluaciondetalle/seccion/evaluaciondetalle_alumno.component';
import { ReporteEvaluacionDetalleGeneralComponent } from './evaluacion/evaluaciondetalle/seccion/evaluaciondetalle_general.component';
import { ReporteEvaluacionDetallePadreComponent } from './evaluacion/evaluaciondetalle/seccion/evaluaciondetalle_padre.component';
import { ColaboradorHijoComponent } from './colaboradorhijo/colaboradorhijo.component';
import { ReporteEvaluacionDetalleTallerAlumnoComponent } from './evaluacion/evaluaciondetalle/seccion/evaluaciondetalle_talleralumno.component';
import { ReporteEvaluacionDetalleTallerPadreComponent } from './evaluacion/evaluaciondetalle/seccion/evaluaciondetalle_tallerpadre.component';

@NgModule({
    imports: [
        CommonModule,
        ComponentesModule,
        TranslateModule,
        FormsModule,
        MatTooltipModule,
        MatTabsModule,
        DxDataGridModule,
        DxCheckBoxModule,
        DxSelectBoxModule,
        DxValidationSummaryModule,
        DxButtonModule,
        DxValidatorModule,
        DxBulletModule,
        DxLoadPanelModule,
        DxTreeViewModule,
        DxListModule,
        DxPivotGridModule,
        AngularSvgIconModule,
        DxContextMenuModule,
        DxTemplateModule,
        PipesModule,
        GlobalModule,
        ReporteRoutingModule,
        DxSortableModule,
        DxTabPanelModule,
        DxAccordionModule
    ],
    declarations: [
        ColaboradorComponent,
        ColaboradorDetalleComponent,
        ReporteEvaluacionPendientePreguntaEnviadaComponent,
        ReporteEvaluacionPendientePreguntaEnviadaDetalleComponent,
        ReporteEvaluacionPendientePreguntaEnviadaDetallePersonaEvaluaComponent,
        ReporteEvaluacionPendientePreguntaEnviadaDetallePreguntaComponent,
        ReporteEvaluacionPendienteComponent,
        ReporteEvaluacionPendienteDetalleComponent,
        ReporteEvaluacionComponent,
        ReporteEvaluacionDetalleComponent,
        ReporteEvaluacionDetalleAlumnoComponent,
        ReporteEvaluacionDetalleTallerPadreComponent,
        ReporteEvaluacionDetalleTallerAlumnoComponent,
        ReporteEvaluacionDetalleGeneralComponent,
        ReporteEvaluacionDetallePadreComponent,
        ColaboradorHijoComponent,
    ],
    entryComponents: [
        ReporteEvaluacionPendientePreguntaEnviadaDetalleComponent,
        ReporteEvaluacionPendientePreguntaEnviadaDetallePersonaEvaluaComponent,
        ReporteEvaluacionPendientePreguntaEnviadaDetallePreguntaComponent,
        ReporteEvaluacionPendienteDetalleComponent,
        ReporteEvaluacionDetalleComponent,
        ReporteEvaluacionDetalleAlumnoComponent,
        ReporteEvaluacionDetalleTallerPadreComponent,
        ReporteEvaluacionDetalleTallerAlumnoComponent,
        ReporteEvaluacionDetalleGeneralComponent,
        ReporteEvaluacionDetallePadreComponent,
    ]
})
export class ReporteModule {}
